import ReceiptPaymentModeSummary from "@/components/receipt-payment-summary/ReceiptPaymentModeSummary";
import {
  buildSabilSummaryQuery,
  SABIL_PAYMENT_SUMMARY_PATH,
  SABIL_SUMMARY_QUERY_KEYS,
  sabilPaymentSummaryCardsFromResponse,
  shouldFetchSabilPaymentSummary,
} from "./sabil-receipt-payment-summary";

export default function SabilReceiptPaymentSummary() {
  return (
    <ReceiptPaymentModeSummary
      apiResource="sabilReceipt"
      summaryPath={SABIL_PAYMENT_SUMMARY_PATH}
      queryKeys={SABIL_SUMMARY_QUERY_KEYS}
      shouldFetch={shouldFetchSabilPaymentSummary}
      buildQuery={buildSabilSummaryQuery}
      cardsFromResponse={sabilPaymentSummaryCardsFromResponse}
    />
  );
}
